import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import 'moment-timezone';


import * as articleActions from '../../state/actions/articles';


class ArticlePreview extends Component {

    handleOnClick() {

        // Get date from the props
        let { uniqueId, articleActions } = this.props;

        let index = ( uniqueId ) ? uniqueId : false;

        // Set the active article
        articleActions.setActiveArticle( index );

    }

    renderSite( article ) {

        return(
            <h4 className="list-group-item-text p-t-1 p-b-1 small" dangerouslySetInnerHTML={{__html: article.site.name}}/>
        )

    }

    renderDate( article ) {

        let date = ( article.date ) ? moment( article.date_gmt ).tz( article.timezone ).format('MM/DD/YYYY h:mm a z') : '';

        return(
            <h4 className="list-group-item-text p-t-1 small" dangerouslySetInnerHTML={{__html: date }}/>
        )

    }

    renderExcerpt( article ) {

        return(
            <p className="list-group-item-text p-t-1" dangerouslySetInnerHTML={{__html: article.excerpt.rendered}}/>
        )

    }

    render() {

        let { article, active, settings } = this.props;

        let itemClass = classNames({
            'list-group-item': true,
            'list-group-item-action': true,
            'active': ( article.uniqueIndex === active ) ? true : false
        });

        return (
            <a href="#" className={itemClass} onClick={this.handleOnClick.bind( this ) }>
                { ( settings.showSite ) ? this.renderSite( article ) : '' }
                <h5 className="list-group-item-heading" dangerouslySetInnerHTML={{ __html: article.title.rendered }} />
                { ( settings.showDate ) ? this.renderDate( article ) : '' }
                { ( settings.showExcerpt ) ? this.renderExcerpt( article ) : '' }
            </a>
        )

    }

}

/**
 * articleActions, sites, settings
 */

function mapStateToProps( state ) {
    return {
        articles: state.articles,
        sites: state.sites,
        settings: state.settings
    }
}

function mapDispatchToProps( dispatch ){
    return {
        articleActions: bindActionCreators( articleActions, dispatch )
    }
}

export default connect( mapStateToProps, mapDispatchToProps )(ArticlePreview);


/** WEBPACK FOOTER **
 ** ./src/components/ArticlePreview/index.js
 **/